const URLUtils = {
  getBaseURL: function() {
    // window.location.host includes port
    let baseUrl = `${window.location.protocol}//${window.location.host}`
    console.log(baseUrl)
    return baseUrl
  },
}

export default URLUtils
